import { formRedirectRegistroCitas } from './formRedirectRegistroCitas';
import { formRedirectPromocionAmnistia } from './formRedirectPromocionAmnistia';
import { formRedirectDemandasMateriaLaboral } from './formRedirectDemandasMateriaLaboral';
import { formRedirectEditarPromocion } from './formRedirectEditarPromocion';
import { formRedirectNuevaPromcocion } from './formRedirectNuevaPromcocion';

export {
    formRedirectRegistroCitas,
    formRedirectPromocionAmnistia,
    formRedirectDemandasMateriaLaboral,
    formRedirectEditarPromocion,
    formRedirectNuevaPromcocion,
}
